module.exports = __webpack_public_path__ + "static/media/dhLock.fcd1f340.jpg";